import React from 'react';
import { connect } from 'react-redux';
import { Tooltip, Box, Stack } from '@mui/material';
import { browserTime, percent, displayDuration } from '../../utils/parsing';
import HeartbeatsGraph from './HeartbeatsGraph';
import { HeartbeatsLoader } from '../loaders/deployments';

const Entry = ({ now, latestHeartbeat: hb, lastContact }) => {
  const contact = lastContact && displayDuration(now - lastContact, 'millis');
  const uptime = hb && displayDuration(hb.uptime_seconds, 'seconds');
  return (
    <Box
      component="span"
      style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
    >
      {contact != null ? (
        <Tooltip tag="contact" title={`Last contact @ ${browserTime(lastContact)}`}>
          Last contact: {contact.val} {contact.unit} ago
        </Tooltip>
      ) : null}
      {hb != null ? (
        <>
          <div>
            Uptime: {uptime.val} {uptime.unit}
          </div>
          <div>
            CPU: {hb.load_1m?.toFixed(1)} / {hb.load_5m?.toFixed(1)} / {hb.load_15m?.toFixed(1)}{' '}
            {hb.cpu_temp_c && `at ${hb.cpu_temp_c} C`}
          </div>
          <div>Memory: {percent(hb.memory)} used</div>
          <div>Disk: {percent(hb.disk_usage)} used</div>
        </>
      ) : (
        <div>No recent heartbeats</div>
      )}
    </Box>
  );
};

const DeploymentMonitor = ({ deployment, latestHeartbeat, now }) => (
  <Stack direction="row">
    <HeartbeatsLoader site={deployment.site} />
    <Entry now={now} latestHeartbeat={latestHeartbeat} lastContact={deployment.last_heartbeat} />
    <HeartbeatsGraph deployment={deployment} />
  </Stack>
);

function mapStateToProps(state, { deployment }) {
  const {
    entities: {
      deployments: { latestHeartbeats },
    },
  } = state;
  const latestHeartbeat = latestHeartbeats[deployment.site];
  return {
    latestHeartbeat,
  };
}

// eslint-disable-next-line no-unused-vars
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(DeploymentMonitor);
